// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sub-admin dashboard (/subadmin). Scoped under .subadmin-dashboard. */

.subadmin-dashboard {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-4);
  min-width: 0;
}

.subadmin-dashboard__welcome {
  margin: 0;
  font-size: var(--ds-title-size);
  font-weight: 700;
  color: var(--ds-text);
}

.subadmin-dashboard .subadmin-dashboard__card {
  height: 100%;
  border-radius: var(--ds-radius-lg);
  box-shadow: var(--ds-shadow-xs);
  min-width: 0;
}

.subadmin-dashboard__widget {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--ds-space-3);
  margin-bottom: var(--ds-space-2);
}

.subadmin-dashboard__widget-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border: 2px solid;
  border-radius: 50%;
  font-size: 20px;
}

.subadmin-dashboard__widget-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--ds-text);
}

.subadmin-dashboard__muted {
  color: var(--ds-text-muted);
}

.subadmin-dashboard__person {
  display: inline-flex;
  align-items: center;
  gap: var(--ds-space-2);
  min-height: 40px;
  color: var(--ds-brand-strong);
}

.subadmin-dashboard__person .ant-avatar {
  flex-shrink: 0;
}

.subadmin-dashboard .subadmin-dashboard__rate {
  font-size: 14px;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/subadmins/components/dashboard/SubadminDashboard.css"],"names":[],"mappings":"AAAA,uEAAuE;;AAEvE;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB","sourcesContent":["/* Sub-admin dashboard (/subadmin). Scoped under .subadmin-dashboard. */\n\n.subadmin-dashboard {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-4);\n  min-width: 0;\n}\n\n.subadmin-dashboard__welcome {\n  margin: 0;\n  font-size: var(--ds-title-size);\n  font-weight: 700;\n  color: var(--ds-text);\n}\n\n.subadmin-dashboard .subadmin-dashboard__card {\n  height: 100%;\n  border-radius: var(--ds-radius-lg);\n  box-shadow: var(--ds-shadow-xs);\n  min-width: 0;\n}\n\n.subadmin-dashboard__widget {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--ds-space-3);\n  margin-bottom: var(--ds-space-2);\n}\n\n.subadmin-dashboard__widget-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  border: 2px solid;\n  border-radius: 50%;\n  font-size: 20px;\n}\n\n.subadmin-dashboard__widget-value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--ds-text);\n}\n\n.subadmin-dashboard__muted {\n  color: var(--ds-text-muted);\n}\n\n.subadmin-dashboard__person {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  min-height: 40px;\n  color: var(--ds-brand-strong);\n}\n\n.subadmin-dashboard__person .ant-avatar {\n  flex-shrink: 0;\n}\n\n.subadmin-dashboard .subadmin-dashboard__rate {\n  font-size: 14px;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
